import { render, staticRenderFns } from "./authOverlay.vue?vue&type=template&id=45a871ab&scoped=true&"
import script from "./authOverlay.vue?vue&type=script&lang=js&"
export * from "./authOverlay.vue?vue&type=script&lang=js&"
import style0 from "./authOverlay.vue?vue&type=style&index=0&id=45a871ab&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a871ab",
  null
  
)

export default component.exports